import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type layoutManagerQuery,
} from '@atlassian/jira-layout-controller/src/controllers/layout-controller/containers/layout-manager/__generated__/layoutManagerQuery.graphql';

export const navigationUIStateRelayResource = createRelayResource<layoutManagerQuery>({
	type: `${RELAY_RESOURCE_TYPE}_NAVIGATION_UI_STATE_RELAY`,
	getQuery: (_, { tenantContext: { cloudId } }) => ({
		parameters: QUERY,
		variables: {
			cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
});
